import { Box, styled } from "@mui/system";
import { Form, Formik } from "formik";

import { Grid } from "@mui/material";
import PrimaryButton from "../../components/custom/PrimaryButton";
import { Stack } from "@mui/material";
import TextField from "../../components/custom/TextField";
import UploadFile from "../../components/custom/UploadFile";
import { useState } from "react";

const UploadFileContainer = styled(Stack)`
  width: 50%;
  justify-content: center;
  margin: auto;
  margin-top: ${(props) => props.theme.spacing(10)};
`;

const TextFieldWithStyle = styled(TextField)`
  & input.Mui-disabled {
    -webkit-text-fill-color: ${(props) =>
      props.theme.palette.secondary.contrastText};
  }

  & .MuiOutlinedInput-root {
    & fieldset {
      border-width: ${(props) =>
        props.disabled ? `0px !important` : `1px !important`};
      border-bottom-width: ${(props) =>
        props.disabled ? `1px !important` : `0px !important`};
      border-radius: ${(props) =>
        props.disabled ? `0px !important` : `inherit !important`};
    }
    background-color: ${(props) =>
      props.disabled ? `transparent` : props.theme.palette.background.paper};
  }
`;

const MyAccountForm = ({
  submitAccountUpdate = () => {},
  data = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    address: "",
    avatar: null,
    city: "",
    zipcode: "",
    country: "",
    phone: "",
  },
}) => {
  const [isDisabled, setIsDisabled] = useState(true);

  return (
    <Box sx={{ mb: 10 }}>
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values) => {
          submitAccountUpdate(values);
          setTimeout(() => setIsDisabled(true), 1000);
        }}
      >
        {({ submitForm, values, dirty, resetForm }) => (
          <Form>
            <Grid container xs={12}>
              <Grid container xs={6}>
                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"First name"}
                  name="firstName"
                />
                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"Last name"}
                  name="lastName"
                />
                <Grid container xs={12}>
                  <Grid item xs={5.5}>
                    <TextFieldWithStyle
                      disabled={isDisabled}
                      label={"Email"}
                      name="email"
                    />
                  </Grid>
                  <Grid xs={1} item />
                  <Grid item xs={5.5}>
                    <TextFieldWithStyle
                      disabled={isDisabled}
                      label={"Password"}
                      name="password"
                      type="password"
                    />
                  </Grid>
                </Grid>

                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"User role"}
                  name="role.description"
                  type="select"
                />
                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"Address"}
                  name="address"
                />
                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"City"}
                  name="city"
                />
                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"Zip code"}
                  name="zipcode"
                />
                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"Country"}
                  name="country"
                />
                <TextFieldWithStyle
                  disabled={isDisabled}
                  label={"Phone"}
                  name="phone"
                />
              </Grid>
              {!isDisabled && (
                <Grid container xs={6} justifyContent="center">
                  <UploadFileContainer
                    direction="row"
                    justifyContent="space-around"
                  >
                    <UploadFile
                      title="My avatar"
                      name="avatar"
                      accept="image/png, image/jpeg"
                    />
                  </UploadFileContainer>
                </Grid>
              )}
            </Grid>
            <Grid container xs={6} direction="row">
              <Grid item xs={10}></Grid>
              {isDisabled && (
                <Grid item xs={2}>
                  <PrimaryButton
                    onClick={() => setIsDisabled(false)}
                    sx={{ my: { xs: 5, md: 10 } }}
                  >
                    Edit
                  </PrimaryButton>
                </Grid>
              )}
              {!isDisabled && (
                <Grid container justifyContent="right">
                  <PrimaryButton
                    disabled={!dirty}
                    onClick={submitForm}
                    sx={{ my: { xs: 5, md: 10 }, mr: { xs: 1, md: 8 } }}
                  >
                    Update
                  </PrimaryButton>
                  <PrimaryButton
                    onClick={() => {
                      setIsDisabled(true);
                      resetForm();
                    }}
                    sx={{ my: { xs: 5, md: 10 } }}
                  >
                    Cancel
                  </PrimaryButton>
                </Grid>
              )}
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

// const distributors = [
//   { value: 1, label: "Distributor 1" },
//   { value: 2, label: "Distributor 2" },
//   { value: 3, label: "Distributor 3" },
//   { value: 4, label: "Distributor 4" },
//   { value: 5, label: "Distributor 5" },
//   { value: 6, label: "Distributor 6" },
//   { value: 7, label: "Distributor 7" },
//   { value: 8, label: "Distributor 8" },
//   { value: 9, label: "Distributor 9" },
//   { value: 10, label: "Distributor 10" },
//   { value: 11, label: "Distributor 11" },
//   { value: 12, label: "Distributor 12" },
//   { value: 13, label: "Distributor 13" },
// ];

export default MyAccountForm;
